{
  "title": "Налаштування",
  "description": "Керування школою. Ця сторінка доступна лише адміністраторам.",
  "school": {
    "title": "Школа",
    "name": "Назва",
    "slug": "Вебадреса (slug)",
    "type": "Тип",
    "types": {
      "organization": "Організація",
      "individual": "Репетитор"
    },
    "defaultLanguage": "Типова мова",
    "timezone": "Часовий пояс",
    "gradingScale": "Шкала оцінювання",
    "gradingScales": {
      "points": "Бали",
      "ua_12": "12-бальна шкала"
    },
    "gradingScaleNote": "Шкала оцінювання впливає лише на те, ЯК показуються оцінки — усі бали зберігаються однаково, тож перемикання шкали не змінює жодної оцінки. Нову шкалу одразу побачать усі у школі.",
    "gradingScaleSaved": "Шкалу оцінювання змінено",
    "gradingScaleFailed": "Не вдалося змінити шкалу оцінювання"
  },
  "createSchool": {
    "title": "Створіть свою школу",
    "description": "Налаштуйте простір для своєї школи чи приватної практики — ви станете її адміністратором.",
    "name": "Назва школи",
    "namePlaceholder": "напр., Ліцей імені Шевченка",
    "type": "Тип",
    "typeOrganization": "Організація — школа з командою вчителів",
    "typeIndividual": "Репетитор — власні класи, без команди",
    "defaultLanguage": "Типова мова",
    "submit": "Створити школу",
    "submitting": "Створення…",
    "failed": "Не вдалося створити школу",
    "validation": {
      "nameRequired": "Вкажіть назву школи"
    }
  },
  "safety": {
    "title": "Безпека",
    "pupilDirectMessages": "Дозволити учням приватне листування між собою",
    "pupilDirectMessagesNote": "Якщо увімкнено, будь-які двоє учнів цієї школи можуть почати приватну розмову, у якій немає жодного вчителя. Типово вимкнено. Писати вчителям і адміністраторам, а також власним батькам, учні можуть завжди — незалежно від цього перемикача.",
    "pupilDirectMessagesOn": "Приватне листування між учнями увімкнено для цієї школи.",
    "pupilDirectMessagesOff": "Приватне листування між учнями вимкнено для цієї школи.",
    "saveFailed": "Не вдалося зберегти налаштування.",
    "moderationLink": "Переглянути скарги на повідомлення"
  },
  "years": {
    "title": "Навчальні роки",
    "description": "Роки впорядковують класи: кожен клас належить до одного року, а поточний рік — типовий для нових класів і списків. Оцінки й відвідуваність автоматично переходять разом із класом.",
    "add": "Додати рік",
    "empty": "Навчальних років ще немає.",
    "current": "Поточний",
    "makeCurrent": "Зробити поточним",
    "currentSet": "{{name}} тепер поточний рік.",
    "edit": "Редагувати {{name}}",
    "delete": "Видалити {{name}}",
    "deleteTitle": "Видалити {{name}}?",
    "deleteDescription": "Видалити можна лише рік без класів — рік із класами є частиною їхньої історії.",
    "deleteConfirm": "Видалити",
    "deleted": "Навчальний рік видалено.",
    "createTitle": "Додати навчальний рік",
    "editTitle": "Редагувати навчальний рік",
    "formDescription": "Назвіть рік так, як заведено у вашій школі, наприклад 2026–2027.",
    "nameLabel": "Назва",
    "namePlaceholder": "2026–2027",
    "startsLabel": "Початок",
    "endsLabel": "Завершення",
    "createSubmit": "Додати рік",
    "saveSubmit": "Зберегти",
    "created": "Навчальний рік додано.",
    "updated": "Навчальний рік оновлено.",
    "saveFailed": "Не вдалося зберегти навчальний рік.",
    "validation": {
      "nameRequired": "Вкажіть назву року.",
      "datesRequired": "Обидві дати обовʼязкові."
    }
  }
}
